import { createUserModel } from '@/core/shared/auth/store/models';
import { createOrganizationModel } from '@/core/shared/vuex-modules/organization';
import { createCountryModel } from '@/core/shared/vuex-modules/country';
import { createRegionModel } from '@/core/shared/vuex-modules/region';

export default schema => {
  const User = createUserModel(schema);
  const Organization = createOrganizationModel(schema);
  const Country = createCountryModel(schema);
  const Region = createRegionModel(schema);

  User.define({
    organization: Organization,
  });

  const TaxForm = new schema.Entity('TaxForm');
  const ContentOwnership = new schema.Entity('ContentOwnership');
  const Bundle = new schema.Entity('Bundle');

  Organization.define({
    taxForm: TaxForm,
  });

  return {
    User,
    Organization,
    Country,
    Region,
    TaxForm,
    ContentOwnership,
    Bundle,
  };
};
